var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVoteDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Downvote"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4 10.0275H8V3.0275C8 2.4775 8.45 2.0275 9 2.0275H15C15.55 2.0275 16 2.4775 16 3.0275V10.0275H20C20.1886 10.0284 20.3731 10.0824 20.5324 10.1834C20.6917 10.2843 20.8193 10.428 20.9007 10.5981C20.9821 10.7682 21.014 10.9578 20.9926 11.1452C20.9713 11.3325 20.8976 11.5101 20.78 11.6575L12.78 21.6475C12.4 22.1175 11.6 22.1175 11.22 21.6475L3.22 11.6475C3.10242 11.5001 3.02874 11.3225 3.00739 11.1352C2.98604 10.9478 3.01789 10.7582 3.09929 10.5881C3.18068 10.418 3.30834 10.2743 3.46764 10.1734C3.62693 10.0724 3.81143 10.0184 4 10.0175V10.0275ZM12 19.4275L17.92 12.0275H15C14.45 12.0275 14 11.5775 14 11.0275V4.0275H10V11.0275C10 11.5775 9.55 12.0275 9 12.0275H6.08L12 19.4275Z",
    fill: "#656565"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVoteDown);
export default __webpack_public_path__ + "static/media/vote-down.1d65669e0a9032d311d4c8a8c0144d94.svg";
export { ForwardRef as ReactComponent };